import { type PoolPayload } from './spell-prep-table';
import { prepPoolFromDefinitions, type PrepInputs } from './spell-prep-inputs';

const inflight = new Map<string, Promise<PoolPayload>>();
const held = new Map<string, PoolPayload>();
const memoKeyOf = (keys: readonly string[]): string => [...new Set(keys)].sort().join(',');
export function heldPrepPool(keys: readonly string[]): PoolPayload | null { return held.get(memoKeyOf(keys)) ?? null; }

export function loadPrepPool(keys: readonly string[], baseUrl: string): Promise<PoolPayload> {
    const key = memoKeyOf(keys), pending = inflight.get(key);
    if (pending) return pending;
    const request = (async (): Promise<PoolPayload> => {
        const response = await fetch(`${baseUrl}options/api/spell_prep_pool_inc.php?c=${encodeURIComponent(key)}&view=table`, { credentials: 'same-origin' });
        if (!response.ok) throw new Error(`spell-prep:inputs-http:${response.status}`);
        const input = await response.json() as PrepInputs;
        if (input.schema !== 'janus.spell_prep_inputs.v1' || !input.base?.catalog || !Array.isArray(input.signatures)) throw new Error('spell-prep:inputs-shape');
        for (const signature of keys) if (!input.signatures.includes(signature)) throw new Error(`spell-prep:missing-signature:${signature}`);
        // Table membership and cells read saved facts through the native layer readers.
        // No worker adoption belongs on the path to the first paint.
        const payload = prepPoolFromDefinitions(input, input.base.catalog);
        held.set(key, payload); return payload;
    })();
    inflight.set(key, request);
    request.catch(() => { if (inflight.get(key) === request) inflight.delete(key); });
    return request;
}
